









































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import GranularitySelect from "@/components/MediumType/GranularitySelect.vue";
import AnalysisMixin from "@/mixins/http/AnalysisMixin";
import {
  PolygonPopulation,
  MediumType,
  ScoutingPlace,
  ScoutingArea,
} from "../../models";
import Percent from "@/filters/Percent";
import FormatNumber from "@/filters/FormatNumber";
import Throttler from "@/utils/Throttler";
import { capitalize } from "../../utils/Typography";
import HeatmapTable from "@/components/HeatmapTable.vue";
import VContentLoading from "@/components/VContentLoading.vue";

@Component({
  components: { GranularitySelect, HeatmapTable, VContentLoading },
  filters: { Percent, FormatNumber },
})
export default class PopulationsTab extends Mixins(AnalysisMixin) {
  @Prop({ required: true }) readonly isocronIds!: string[];
  @Prop({
    default: () => {
      return [];
    },
  })
  readonly areaIds!: string[];

  private populations: PolygonPopulation[] = [];
  private granularity = "region";
  private loading = false;
  private throttler: Throttler = new Throttler();

  get columns() {
    return [
      { name: this.granularity, label: this.granularityName },
      { name: "population", label: "Popolazione" },
      { name: "families", label: "Famiglie" },
      {
        name: "ratio",
        label: "%",
        tooltip: "Percentuale di abitanti rispetto al singolo territorio",
      },
    ];
  }

  mounted() {
    this.load();
  }

  @Watch("isocronIds")
  onIsocronIdsChanged() {
    this.throttler.run(() => {
      this.load();
    });
  }

  @Watch("areaIds")
  onAreaIdsChanged() {
    this.throttler.run(() => {
      this.load();
    });
  }

  get granularityName() {
    const name =
      MediumType.granularities.find((o) => o.id === this.granularity)?.name ||
      "-";
    return capitalize(name);
  }

  onGranularitySelected(granularity: string) {
    this.granularity = granularity;
    this.load();
  }

  get payload() {
    return {
      granularity: this.granularity,
      isocron_ids: this.isocronIds,
      area_ids: this.areaIds,
    };
  }

  async load() {
    this.populations = [];
    this.loading = true;
    this.populations = await this.getPolygonPopulations(this.payload);
    this.loading = false;
  }
}
